export default "__VITE_ASSET__B8L8_Rmg__"